module.exports = __webpack_public_path__ + "static/img/fund_deposit.cb9fae5.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/fund_deposit.svg
// module id = dfD5
// module chunks = 4